

export default {
  SET_ITEMS(state, payload) {
    state.clients = payload
  },

  SET_ITEMS_FULL_NAME(state, payload) {
    state.fullNameClients = payload
  },

  ADD_ITEM(state, payload) {
    state.clients.push(payload)
  },

  UPDATE_ITEM(state, payload) {
      const ItemIndex = state.clients.findIndex((p) => p.id == payload.id)
      Object.assign(state.clients[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.clients.findIndex((p) => p.id == itemId)
      state.clients.splice(ItemIndex, 1)
  },

  SET_CLIENTS_HAVE_INVOICE(state, payload) {
    state.countClientsHaveInvoice = payload
  },

}
